import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/migration/center/tenant.migration.center.query.gql"
import type {
  MigrationCenterQuery,
  MigrationCenterQueryVariables,
} from "@/v2-backoffice-client/tenant/migration/center/__types__/tenant.migration.center.query"

type Options = QueryHookOptions<
  MigrationCenterQuery,
  MigrationCenterQueryVariables
>

// The Migration Center's batched member boards: one group per selected
// tenant, same row shape (and server-derived Status) as the single-tenant
// Fusion Login dialog.
export function useMigrationCenterQuery(options?: Options) {
  return useQuery<MigrationCenterQuery, MigrationCenterQueryVariables>(
    query,
    options,
  )
}
